import { render, staticRenderFns } from "./SuccessRegistered.vue?vue&type=template&id=69c28782&scoped=true"
import script from "./SuccessRegistered.vue?vue&type=script&lang=js"
export * from "./SuccessRegistered.vue?vue&type=script&lang=js"
import style0 from "./SuccessRegistered.vue?vue&type=style&index=0&id=69c28782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c28782",
  null
  
)

export default component.exports